var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"header"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPage === 'Analysis'),expression:"currentPage === 'Analysis'"}],staticClass:"header__logo"},[_c('a',{staticClass:"text-hide",attrs:{"href":"./"}},[_vm._v("信義房屋 - 全台唯一直營上市房仲品牌")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }